import { SvelteToast } from "@zerodevx/svelte-toast"
import { createInertiaApp } from "@inertiajs/svelte"
import { mount } from "svelte"

import "./application.css"
document.addEventListener("DOMContentLoaded", () => {
  mount(SvelteToast, { target: document.getElementById("toast-cont") })
})

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob("../Pages/**/*.svelte", {
      eager: true
    })
    return pages[`../Pages/${name}.svelte`]
  },
  setup({ el, App, props }) {
    if (el) {
      mount(App, { target: el, props })
    }
  }
})
